import { render, staticRenderFns } from "./VueGuspreadTableTr.vue?vue&type=template&id=203e328d&"
import script from "./VueGuspreadTableTr.vue?vue&type=script&lang=js&"
export * from "./VueGuspreadTableTr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports